module.exports = __webpack_public_path__ + "img/st.bc5c4538.svg";